// Debug utility to check email configuration
import { EMAIL_CONFIG } from '../config/email';

/**
 * Check email configuration and log diagnostic information
 */
export function debugEmailConfig(): void {
  console.group('📧 Email Configuration Debug');
  console.log('Email notifications enabled:', EMAIL_CONFIG.ENABLED);
  console.log('Public Key:', EMAIL_CONFIG.PUBLIC_KEY ? `${EMAIL_CONFIG.PUBLIC_KEY.substring(0, 10)}...` : 'NOT SET');
  console.log('Service ID:', EMAIL_CONFIG.SERVICE_ID || 'NOT SET');
  console.log('Template ID:', EMAIL_CONFIG.TEMPLATE_ID || 'NOT SET');
  console.log('Notification Email:', EMAIL_CONFIG.NOTIFICATION_EMAIL || 'NOT SET');
  
  const missingConfig = [];
  if (!EMAIL_CONFIG.PUBLIC_KEY) missingConfig.push('PUBLIC_KEY');
  if (!EMAIL_CONFIG.SERVICE_ID) missingConfig.push('SERVICE_ID');
  if (!EMAIL_CONFIG.TEMPLATE_ID) missingConfig.push('TEMPLATE_ID');
  if (!EMAIL_CONFIG.NOTIFICATION_EMAIL) missingConfig.push('NOTIFICATION_EMAIL');
  
  if (missingConfig.length > 0) {
    console.warn('⚠️ Missing configuration:', missingConfig.join(', '));
    console.warn('Please check your .env file and ensure all EmailJS values are set.');
  } else {
    console.log('✅ All configuration values are set');
  }
  
  // Check environment variables directly
  console.log('\nEnvironment Variables (from process.env):');
  console.log('REACT_APP_EMAILJS_PUBLIC_KEY:', process.env.REACT_APP_EMAILJS_PUBLIC_KEY ? `SET (${process.env.REACT_APP_EMAILJS_PUBLIC_KEY.substring(0, 10)}...)` : 'NOT SET');
  console.log('REACT_APP_EMAILJS_SERVICE_ID:', process.env.REACT_APP_EMAILJS_SERVICE_ID || 'NOT SET');
  console.log('REACT_APP_EMAILJS_TEMPLATE_ID:', process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'NOT SET');
  console.log('REACT_APP_NOTIFICATION_EMAIL:', process.env.REACT_APP_NOTIFICATION_EMAIL || 'NOT SET');
  console.log('REACT_APP_EMAIL_NOTIFICATIONS_ENABLED:', process.env.REACT_APP_EMAIL_NOTIFICATIONS_ENABLED);
  
  // Check if .env file exists (for debugging)
  console.log('\nDebug Info:');
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('All REACT_APP_ vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
  
  console.groupEnd();
}

